import { __rest } from "tslib";
import React, { useEffect, useCallback } from 'react';
import { apiHolder as api, isElectron } from 'api';
import throttle from 'lodash/throttle';
const getScreenCapture = api.api.getSystemApi().getScreenCapture;
const HOCCaptureScreen = (Component) => {
    const CaptureScreen = (props) => {
        const { ref } = props, rest = __rest(props, ["ref"]);
        const instanceRef = React.useRef(null);
        const captureScreenAction = (editor, hideCur) => {
            if (!editor)
                return;
            console.log('captureScreenAction--------');
            instanceRef.current = editor;
            console.log('value', hideCur);
            getScreenCapture({ from: 'editorMail', hideCur });
        };
        const handleCaptureScreenAction = useCallback(throttle(captureScreenAction, 5000, { trailing: false }), []);
        useEffect(() => {
            if (isElectron()) {
                console.log('get-capture-screen-data1111');
                window.electronLib.ipcChannelManage.receiveIpcMain({
                    channel: 'get-capture-screen-data',
                    listener: rest => {
                        var _a;
                        console.log('get-capture-screen-data', rest);
                        const from = rest.from;
                        if (from !== 'editorMail')
                            return;
                        (_a = instanceRef.current) === null || _a === void 0 ? void 0 : _a.pasteHtml(instanceRef.current, `<img src="${rest.url}" />`);
                    },
                });
            }
            return () => {
                if (isElectron()) {
                    window.electronLib.ipcChannelManage.removeListener('get-capture-screen-data');
                }
            };
        }, []);
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, captureScreenAction: handleCaptureScreenAction }))));
    };
    return React.forwardRef((props, ref) => React.createElement(CaptureScreen, Object.assign({}, props, { ref: ref })));
};
export default HOCCaptureScreen;
